module.exports = __webpack_public_path__ + "static/media/AkkuratLight.f5fff518.eot";